// Legenda da consulta_producao TELA-1 (textos do form; cores de COR-TABELA, TELA-1.prc L656-672):
// no prazo = azul sobre branco · atrasada (Etapa) = texto vermelho · (Dt Entrega) = fundo vermelho ·
// (Data e Etapa) = fundo preto — aplicadas em Data Entrega e Tempo Prod.
const ITENS: { rotulo: string; estilo: React.CSSProperties }[] = [
  { rotulo: "PCF no prazo", estilo: { background: "#fff", color: "#1565c0" } },
  { rotulo: "PCF atrasada (Etapa)", estilo: { background: "#fff", color: "#d32f2f", fontWeight: 600 } },
  { rotulo: "PCF atrasada (Dt Entrega)", estilo: { background: "#d32f2f", color: "#fff" } },
  { rotulo: "PCF atrasada (Data e Etapa)", estilo: { background: "#111", color: "#fff" } },
];

export function LegendaLinhas() {
  return (
    <div className="legenda-linhas">
      <span className="leg-title">Legenda</span>
      {ITENS.map((i) => (
        <span key={i.rotulo} className="leg-item" style={{ ...i.estilo, padding: "2px 8px", borderRadius: 4, border: "1px solid #ccc" }}>
          {i.rotulo}
        </span>
      ))}
    </div>
  );
}
